import React from 'react';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import typography from '@/styles/typography.module.scss';

import { WrapperConverterContent, WrapperConverterFields } from '../Wrappers';
import styles from './styles.module.scss';

interface Props {
  children: React.ReactNode;
  slot?: React.ReactNode;
}

function ConverterResultPanelTitle() {
  const tr = useTranslations();

  return (
    <div>
      <p className={typography.h4}>
        {tr.rich('pages.converters.index.sections.converterFields.result.title')}
      </p>
      <p className={classNames(typography.subheadingM, styles.subtitle)}>
        {tr.rich('pages.converters.index.sections.converterFields.result.subtitle')}
      </p>
    </div>
  );
}

export function ConverterResultPanel({ children, slot }: Props) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <WrapperConverterContent>
          <ConverterResultPanelTitle />
          <WrapperConverterFields>{children}</WrapperConverterFields>
          {slot}
        </WrapperConverterContent>
      </div>
    </div>
  );
}
